export default __webpack_public_path__ + "static/media/implementContactless.24df0895.jpg";